import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function CountdownBanner() {
  const INITIAL_TIME = 14 * 60 + 50;
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          return INITIAL_TIME;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A] text-white py-2 px-4 text-center shadow-lg border-b-2 border-[#8FF650]" data-id="element-85">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-sm md:text-base font-bold tracking-wide" data-id="element-86">
        <div className="flex items-center gap-2 text-[#8FF650]" data-id="element-87">
          <Timer className="w-5 h-5 animate-pulse" data-id="element-88" />
          <span data-id="element-89">⏳ OFERTA EXPIRA EN: {formattedTime}</span>
        </div>
        <span className="hidden md:inline text-gray-600" data-id="element-90">|</span>
        <div className="text-[#8FF650] animate-pulse" data-id="element-91">
          🔥 SOLO QUEDAN 3 CUPOS
        </div>
      </div>
    </div>;
}